/* eslint-disable arrow-body-style */

import React from 'react';
import Loading from '@gp/components/Loading';
import OperationBtns from '@gp/components/OperationBtns';
import ActionItem from './Item';

import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';

interface IActionItemsProps extends IBaseProps {
  isSynchronizing?: boolean;
  isEmpty?: boolean;
  list?: IRecord[] | null;
  onAdd?: (type: 'init' | 'add') => void;
  onDelete?: (index: number) => void;
  onSynchronize?: () => void;
  onChange?: (index: number, payload: IRecord) => void;
}

const ActionItems: React.FC<IActionItemsProps> = (props) => {
  const { isSynchronizing = false, isEmpty = true, list, onAdd, onDelete, onSynchronize, onChange } = props;

  return (
    <>
      {isSynchronizing && (
        <div className="dbg-gr-action-items__state-wrapper dbg-gr-action-items__loading">
          <Loading loading loadingText="Auto-synchronizing..." />
        </div>
      )}
      {!isSynchronizing && isEmpty && (
        <OperationBtns
          className="dbg-update-project-edit-operate"
          isShowAdd
          onAdd={() => {
            onAdd?.('init');
          }}
        />
      )}
      {!isSynchronizing && !isEmpty && (
        <div className="dbg-edit-form-box">
          <a
            className="dbg-edit-form-box-btn"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onSynchronize?.();
            }}
          >
            Synchronize all incomplete Action Items
          </a>
          {list?.map((item, index) => {
            return (
              <ActionItem
                key={index}
                index={index}
                isShowDelete={list!.length > 1}
                isShowAdd={index === list!.length - 1}
                data={item}
                onAdd={() => {
                  onAdd?.('add');
                }}
                onDelete={() => {
                  onDelete?.(index);
                }}
                onChange={(payload) => {
                  onChange?.(index, payload);
                }}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default ActionItems;
